import {Room} from "@/core/api/room.api";

export default function roomLmsEventListener(room) {
  return store => {
    room.addEventListeners({
      room_user_enter: data => {
        if (!Room.RoomInfo.useLmsAbsentees()) {
          return;
        }

        store.commit('lms/DELETE_LMS_USER', data.data.roomUser);
      },
      room_user_leave: data => {
        if (!Room.RoomInfo.useLmsAbsentees()) {
          return;
        }

        store.commit('lms/ADD_LMS_USER', data.data.roomUser);
      },
      room_lms_user_list_set: data => {
        if (!Room.RoomInfo.useLmsAbsentees()) {
          return;
        }

        store.commit('lms/SET_LMS_USER_LIST', data.data);
      },
    });
  }
}